var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"zwxScreen",staticClass:"zwx-screen",style:(_vm.screenStyles)},[_c('div',{staticClass:"wrap",style:(_vm.wrapStyles)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }